const escapeCell = (value) => String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");

const buildHeaderCell = (h) => `<th>${escapeCell(h)}</th>`;

const buildDataCell = (cell) => `<td>${escapeCell(cell)}</td>`;

const buildRow = (row) => {
    const cellsHtml = row.map(buildDataCell).join("");
    return `<tr>${cellsHtml}</tr>`;
};

export const buildXlsHtml = (headers, rows) => {
    const headerHtml = headers.map(buildHeaderCell).join("");
    const rowsHtml = rows.map(buildRow).join("");
    const headerRowHtml = `<tr>${headerHtml}</tr>`;

    return [
        '<html xmlns:o="urn:schemas-microsoft-com:office:office"',
        ' xmlns:x="urn:schemas-microsoft-com:office:excel"',
        ' xmlns="http://www.w3.org/TR/REC-html40">',
        '<head><meta charset="UTF-8"></head>',
        '<body><table border="1">',
        `<thead>${headerRowHtml}</thead>`,
        `<tbody>${rowsHtml}</tbody>`,
        "</table></body></html>",
    ].join("");
};

export const downloadXls = (headers, rows, filename) => {
    const html = buildXlsHtml(headers, rows);
    const blob = new Blob([html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};